import type { PermissionItem } from './types'

import { Permission } from '@/types/schema/permissions'

export const UserPermissions = {
  READ: [Permission.UserRead],
  UPDATE: [Permission.UserUpdate],
  CREATE: [Permission.UserCreate],
  DELETE: [Permission.UserDelete],
}

// User management permissions
export const userPermissions: PermissionItem[] = [
  {
    id: Permission.UserRead,
    title: 'View users',
    description:
      'A user can access the user management page and view user details',
  },
  {
    id: Permission.UserCreate,
    title: 'Create users',
    description: 'A user can create new users',
  },
  {
    id: Permission.UserUpdate,
    title: 'Update users',
    description: 'A user can modify user settings',
  },
  {
    id: Permission.UserDelete,
    title: 'Delete users',
    description: 'A user can delete users',
  },
]
